import React from 'react';

const themeContext = React.createContext();
const {Provider, Consumer} = themeContext;

export default themeContext;
export { Provider, Consumer };
